import { createUrl, restPatch } from '~/src/dash/api/rest';
import { EBool } from '~/src/dash/api/types/bool';

interface IPublisherTrafficShapingPatch {
  EnableTrafficShaping: EBool;
}

export interface IPublisherTrafficShapingResponse {
  success: boolean;
  msg: string;
  EnableTrafficShaping?: EBool;
}

export async function patchPublisherTrafficShaping(
  publisherID: string,
  trafficShaping: IPublisherTrafficShapingPatch,
): Promise<IPublisherTrafficShapingResponse> {
  const reqUrl = `${createUrl('/update_publisher_traffic_shaping', publisherID, 'v1')}`;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const response = await restPatch<any>(reqUrl, trafficShaping);
  return response.parsedBody as IPublisherTrafficShapingResponse;
}
